<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-25 
-->
<template>
  <div class="news-item">
    <div class="news-img" @click="handleLook">
      <img :src="itemDetail.listLogoPath" />
    </div>
    <div class="news-content">
      <div class="title" @click="handleLook">{{itemDetail.title}}</div>
      <div class="time">{{itemDetail.publishTime | time_moment}}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  inject: ['globalInsertRecords'],
  props: {
    itemDetail: {
      default: () => {},
    }
  },
  components: {},
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      vbef_path: (state) => state.vbef_path,
      isMobile: (state) => state.isMobile,
      language: (state) => state.language,
    }),
  },
  methods: {
    handleLook() {
      this.globalInsertRecords({
        contentId: this.itemDetail.contentId,
        contentType: 3,
        viewType: 1
      })
      let str = ''
      if(this.language =='zh') str = `?language=zh`
      let href = `${this.vbef_path}/newsDetail/${this.itemDetail.contentId}${str}`
      if(this.isMobile) window.location.href = href
      else window.open(href, '_blank')
    }
  },
}
</script>
<style lang='stylus' scoped>
.news-item
  width 356px
  max-width 356px
  min-width 356px
  box-shadow 0px 6px 16px 0px rgba(0, 0, 0, 0.1)
  .news-img
    width 100%
    height 200px
    cursor pointer
    overflow hidden
    img
      width 100%
      height 100%
      object-fit cover
      transition all 0.3s
    &:hover
      img
        transform scale(1.2)
  .news-content
    padding 20px 20px 25px
    background #fff
    .title
      font-size 18px
      color #333333
      line-height 24px
      cursor pointer
      transition: all .3s
      &:hover
        color #c8161d
    .time
      font-size 14px
      color #86909C
      line-height 12px
      margin-top 20px
</style>